@let isAllowBonusCodeForCurrentPtag = controller.isAllowBonusCodeForPtag$ | async;

@if (controller.enhancedReg$ | async) {
  <div class="sign-up-container">
    <i #close class="close icon-close" (click)="onClose()"></i>
    <form class="form-container" [formGroup]="controller.enhancedRegisterForm">
      @if (!controller.isSecondStep()) {
        <ng-container *ngTemplateOutlet="bannerContent"></ng-container>
        <div class="form">
          <div class="form__title desktop" id="sign-up-title">{{ 't.create-account' | translate }}</div>
          <div>
            <div>
              <app-form-input class="input-item" [control]="controller.enhancedRegisterForm.get('email')" [label]="'labl.email' | translate">
                <input class="input input--simple input--email" (focus)="onFocus($event)" type="text" name="email"
                       id="email-input"
                       formControlName="email">
              </app-form-input>

              <app-form-input class="input-item has-icon" [control]="controller.enhancedRegisterForm.get('password')" [label]="'labl.password' | translate">
                <i class="icon icon-password password-toggle" [ngClass]="{'icon--ios': body.IOS}"></i>
                <input (keydown.space)="$event.preventDefault()" class="input input--simple" (focus)="onFocus($event)" type="password" name="password" PasswordShow formControlName="password"  id="password-input">
              </app-form-input>

              <app-form-input class="input-item"
                              [control]="controller.enhancedRegisterForm.get('mobile_phone')">
                <app-phone-form formControlName="mobile_phone"></app-phone-form>
              </app-form-input>
            </div>

            <ng-container *ngTemplateOutlet="bonusCodePart; context: {form: controller.enhancedRegisterForm}"></ng-container>

            <div class="checkbox-container pt-10">
              <div class="checkbox-container__checkbox">
                <app-form-checkbox [control]="controller.enhancedRegisterForm.get('terms_acceptance')" id="terms-checkbox"
                                   (change$)="controller.toggleRegistrationDataToStorage(controller.enhancedRegisterForm, false, true); $event.stopPropagation()"
                                   [label]="'t.agree-terms' | translate"
                                   [checked]="controller.enhancedRegisterForm.get('terms_acceptance')?.value"
                                   [borderColor]="'#8C8C8C'"
                                   [styles]="{'align-items': 'flex-start'}"
                >
                </app-form-checkbox>
              </div>

              <div class="checkbox-container__checkbox">
                <app-form-checkbox [control]="controller.enhancedRegisterForm.get('receive_promos')" id="receive-email-checkbox"
                                   (change$)="controller.toggleRegistrationDataToStorage(controller.enhancedRegisterForm, false, true); $event.stopPropagation()"
                                   [label]="'labl.recive-email' | translate"
                                   [checked]="controller.enhancedRegisterForm.get('receive_promos')?.value"
                                   [borderColor]="'#8C8C8C'"
                >
                </app-form-checkbox>
              </div>
            </div>

            <div class="submit-container">
              <button
                (click)="controller.onClickStep()" type='button'
                class="btn btn--filled-primary"
              >{{ 'btn.next-step' | translate }} </button>
            </div>
          </div>

          <app-social-auth></app-social-auth>

          <div class="bottom-links">
            <div class="bottom-links__item">{{'t.already-have-acc' | translate}} <a (click)="onLoginClick()"><span class="link ">{{'t.log-in' | translate}}</span></a></div>
          </div>
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="bannerContent"></ng-container>
        <div class="form">
          <div class="desktop flex flex-row-reverse flex-center">
            <div class="form__title w-100" id="sign-up-title">{{ 't.create-account' | translate }}</div>
            <i class="back-arrow icon-arrow-thin" (click)="controller.isSecondStep.set(false)"></i>
          </div>
          <app-auth-fields-missed
            [fieldsList$]='fieldsList$'
            [hideTitle]='true'
            [buttonName]="'btn.singup'"
            (onSubmit$)='controller.onEnhancedRegSubmit($event)'></app-auth-fields-missed>
        </div>
      }
    </form>
  </div>
} @else {
  <ng-container *ngTemplateOutlet="defaultReg"></ng-container>
}


<ng-template #defaultReg>
  <div class="sign-up-container">
    <i #close class="close icon-close" (click)="onClose()"></i>
    <div class="form-container">
      <ng-container *ngTemplateOutlet="bannerContent"></ng-container>

      <div class="form">
        <div class="form__title desktop" id="sign-up-title">{{ 't.create-account' | translate }}</div>

        <form [formGroup]="controller.form" (ngSubmit)="controller.onRegSubmit()">
          <div>
            <app-form-input class="input-item" [control]="controller.input('email')" [label]="'labl.email' | translate">
              <input class="input input--simple input--email" (focus)="onFocus($event)" type="text" name="email"
                     id="email-input"
                     formControlName="email">
            </app-form-input>

            <app-form-input class="input-item has-icon" [control]="controller.input('password')" [label]="'labl.password' | translate">
              <i class="icon icon-password password-toggle" [ngClass]="{'icon--ios': body.IOS}"></i>
              <input (keydown.space)="$event.preventDefault()" class="input input--simple" (focus)="onFocus($event)" type="password" name="password" PasswordShow formControlName="password"  id="password-input">
            </app-form-input>
          </div>

          <ng-container *ngTemplateOutlet="bonusCodePart; context: {form: controller.form}"></ng-container>

          <div class="checkbox-container pt-10">
            <div class="checkbox-container__checkbox">
              <app-form-checkbox [control]="controller.input('terms_acceptance')" id="terms-checkbox"
                                 (change$)="controller.toggleRegistrationDataToStorage(controller.form, false); $event.stopPropagation()"
                                 [label]="'t.agree-terms' | translate"
                                 [checked]="controller.input('terms_acceptance')?.value"
                                 [borderColor]="'#8C8C8C'"
                                 [styles]="{'align-items': 'flex-start'}"
              >
              </app-form-checkbox>
            </div>

            <div class="checkbox-container__checkbox">
              <app-form-checkbox [control]="controller.input('receive_promos')" id="receive-email-checkbox"
                                 (change$)="controller.toggleRegistrationDataToStorage(controller.form, false); $event.stopPropagation()"
                                 [label]="'labl.recive-email' | translate"
                                 [checked]="controller.input('receive_promos')?.value"
                                 [borderColor]="'#8C8C8C'"
              >
              </app-form-checkbox>
            </div>
          </div>

          <div class="submit-container">
            <button
              class="btn btn--filled-primary"
              id="submit-register-button"
              [loading]='controller.loading()'
            >{{'btn.signup' | translate}}</button>
          </div>
        </form>

        <app-social-auth></app-social-auth>

        <div class="bottom-links">
          <div class="bottom-links__item">{{'t.already-have-acc' | translate}} <a (click)="onLoginClick()"><span class="link ">{{'t.log-in' | translate}}</span></a></div>
        </div>
      </div>
    </div>

  </div>
</ng-template>

<ng-template #bannerContent>
  @if (controller.isSecondStep()) {
    <div class="mobile w-100 flex flex-row-reverse flex-center">
      <div class="form__title mobile w-100" id="sign-up-title-mobile">{{ 't.create-account' | translate }}</div>
      <i class="back-arrow icon-arrow-thin" (click)="controller.isSecondStep.set(false)"></i>
    </div>
  } @else {
    <div class="form__title mobile" id="sign-up-title-mobile">{{ 't.create-account' | translate }}</div>
  }
  @if (banner()) {
    <div class="bonus">
      <div class="bonus__text">
        <div class="bonus__title">{{ banner().Title }}</div>
        <div class="bonus__description" [innerHTML]="banner()?.Description | safe:'html'"></div>
      </div>
      @if (banner()?.ImageRedesign || banner()?.ImageRedesign) {
        <img class="bonus__image desktop" [src]="banner()?.ImageRedesign" alt="">
        <img class="bonus__image mobile" [src]="banner()?.ImageRedesign" alt="">
      } @else {
        <img class="bonus__image desktop" src="/assets/img/default-welcome-bonus.png" alt="">
      }
    </div>
  } @else {
    <div class="bonus"></div>
  }
  <ng-template #bonus>
    <div class="bonus"></div>
  </ng-template>
</ng-template>

<ng-template #bonusCodePart let-form="form">
  @if (!controller.isPtag() || isAllowBonusCodeForCurrentPtag) {
    <div  #bonusAccordion Accordion class="bonuscode-link" (click)="focusCode(inputElement)">
      <span class="link ">{{'t.have-bonus-code' | translate}}</span>
    </div>
    <div class="bonus-code-form">
      <app-form-input class="bonus-code-form__input" [control]="form.get('bonus_code')">
        <input #inputElement [placeholder]="'bonus.code' | translate"  [formControl]="form.get('bonus_code')" type="text" id="bonus-code-input">
      </app-form-input>
      @if (!isSubmitedBonusCode()) {
        <button
          type="button"
          (click)="onBonuscodeFormSubmit(form)"
          [disabled]="!form.get('bonus_code').value || form.get('bonus_code').invalid"
          class="bonus-code-form__action btn btn--primary">
          {{'btn.send' | translate}}
        </button>
      }
      @if (isSubmitedBonusCode()) {
        <button
          type="button"
          class="bonus-code-form__action btn btn--primary"
          (click)="deleteDepositeBonus(form)">
          {{'btn.clear' | translate}}
        </button>
      }
    </div>
  }
</ng-template>
